export var ValueSex;
(function (ValueSex) {
    ValueSex["Male"] = "M";
    ValueSex["Female"] = "F";
    ValueSex["Intersex"] = "X";
    ValueSex["Unknown"] = "U";
    ValueSex["NotRecorded"] = "N";
})(ValueSex || (ValueSex = {}));
//# sourceMappingURL=ValueSex.js.map